<!--
* @Name：对账单审批
* @Author: 刘玉
* @Date: 2021-12-02 10:47:19
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 10:47:19
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="对账单审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">对账单基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="invoiceInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">发票信息</span>
        </template>
        <invoice-info
          :invoice-date="headInfo.invoiceDate"
          :drawer-name="headInfo.drawerName"
          :invoice-list="invoiceList"
        />
      </van-collapse-item>
      <van-collapse-item name="defectiveChipInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">芯片不良品处理明细信息</span>
        </template>
        <defective-chip-info :chipInfo="chipInfo" />
      </van-collapse-item>
      <van-collapse-item name="accountOrderDetails" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">对账单明细信息</span>
        </template>
        <account-order-details :details-info="detailsInfo" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批页面</span>
        </template>
        <hi-flow-approval :details-info="detailsInfo" :page-context="thisPage" @get-process-info="onGetProcessInfo" />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import {
  selectByStatementCode,
  detailPageByStatementCode,
  detailChipPageByStatementCode,
  checkInVerifyNode
} from '@/api/accountOrder'
import Bridge from '@/components/dsbridge'
export default {
  name: 'AccountOrderApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'invoice-info': () => import('./components/InvoiceInfo.vue'),
    'account-order-details': () => import('./components/AccountOrderDetails'),
    'defective-chip-info': () => import('./components/DefectiveChipInfo')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      headInfo: {},
      detailsInfo: [],
      invoiceList: [],
      // 芯片不良品处理明细信息 数据源
      chipInfo: [],
      taskDefinitionKey: ''
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    thisPage() {
      return this
    }
  },
  methods: {
    async initData() {
      // const headResp = await selectByStatementCode(this.$store.getters.businessKey)
      const headResp = await selectByStatementCode(this.$route.query.businessKey)
      this.headInfo = headResp.data
      this.invoiceList = headResp.data.statementInvoiceDtos || []
      // const query = { statementCode: this.$store.getters.businessKey }
      const query = { statementCode: this.$route.query.businessKey }
      const detailsResp = await detailPageByStatementCode(query)
      this.detailsInfo = detailsResp.data
      const detailsChipResp = await detailChipPageByStatementCode(query)
      this.chipInfo = detailsChipResp.data
    },
    onGetProcessInfo(processInfo) {
      this.taskDefinitionKey = processInfo.taskDefKey
    },
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  },
  bpmHooks: {
    // 采购核对节点，审批前调接口判断
    async beforeExecute(type) {
      if (type === 'agree') {
        if (this.taskDefinitionKey === 'Activity_0sgdmkf') {
          const res = await checkInVerifyNode(this.headInfo.statementCode)
          console.log(res)
          if (!res.success) {
            this.$notify({
              title: '提示',
              message: res.message,
              type: 'warning'
            })
            // 中断审批
            throw Error()
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
